(ns app.front.ui.styled-sticky
  "Wrapper element that can be styled based on its sticky position state"
  (:require [potpuri.core :as p]
            [reagent.core :as r]))

(defn styled-sticky [{:keys [get-top]} & _]
  (let [*ref       (r/atom nil)
        *sticking? (r/atom false)
        *top       (r/atom 0)
        on-scroll  (fn []
                     (when @*ref
                       (let [render-top (some-> (.getBoundingClientRect @*ref)
                                                .-top)
                             layout-top (some-> (.getComputedStyle js/window @*ref)
                                                .-top
                                                js/parseFloat)]
                         (reset! *sticking? (<= render-top layout-top))
                         (when (fn? get-top)
                           (reset! *top (get-top @*ref))))))]
    (r/create-class
      {:component-did-mount
       (fn []
         (.addEventListener js/window "scroll" on-scroll #js {:passive true})
         (.addEventListener js/window "resize" on-scroll)
         (on-scroll))
       :component-will-unmount
       (fn []
         (.removeEventListener js/window "scroll" on-scroll)
         (.removeEventListener js/window "resize" on-scroll))
       :reagent-render
       (fn [props & children]
         (let [top (or (:top props) @*top)]
           (into [(:tag props)
                  (merge (->> props
                              (p/remove-keys #{:tag :sticky-class :get-top :top}))
                         {:ref   #(reset! *ref %)
                          :class (cond->> (:class props)
                                   @*sticking? (concat (:sticky-class props)))
                          :style {:top (str top "px")}})]
                 children)))})))
